// Мелочи, которые одинаково нужны боту, админке и игре.

/** 3 720 000 → «1 ч 2 мин» */
export function formatDuration(ms: number): string {
  if (!ms || ms < 0) return "0 с";
  const totalSeconds = Math.round(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours) return minutes ? `${hours} ч ${minutes} мин` : `${hours} ч`;
  if (minutes) return seconds ? `${minutes} мин ${seconds} с` : `${minutes} мин`;
  return `${seconds} с`;
}

/** 95 000 → «1:35» для секундомера в игре */
export function formatClock(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

/** Имя игрока для списков: имя плюс первая буква фамилии */
export function playerName(first: string | null, last: string | null, username: string | null): string {
  const name = [first, last?.slice(0, 1)].filter(Boolean).join(" ").trim();
  return name || username || "Игрок";
}

const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

/** Реферальный код: без похожих друг на друга символов, чтобы диктовать вслух */
export function generateReferralCode(length = 8): string {
  let out = "";
  for (let i = 0; i < length; i++) {
    out += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
  }
  return out;
}

export function pluralize(count: number, forms: [string, string, string]): string {
  const n = Math.abs(count) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) return forms[2];
  if (n1 > 1 && n1 < 5) return forms[1];
  if (n1 === 1) return forms[0];
  return forms[2];
}

/** Московское время: сервер и бот живут в нём, часовые пояса игроков не учитываем */
export function moscowHour(date = new Date()): number {
  return Number(
    new Intl.DateTimeFormat("ru-RU", {
      timeZone: "Europe/Moscow",
      hour: "2-digit",
      hour12: false,
    }).format(date),
  );
}

/** Понедельник текущей недели по московскому времени — граница недельного лидерборда */
export function weekStart(date = new Date()): Date {
  const msk = new Date(date.toLocaleString("en-US", { timeZone: "Europe/Moscow" }));
  const day = (msk.getDay() + 6) % 7;
  msk.setHours(0, 0, 0, 0);
  msk.setDate(msk.getDate() - day);
  return msk;
}
